import React, { useEffect, useState } from 'react';
import '../css/LoginPage.css';
import Footer from './Footer';
import MultiActivityGoalCalendar from './GoalCalendar';
import ProfileNavBar from './ProfileNavBar';
import UserComparison from './UserComparison';
import AreasOfImprovementChart from './AreasOfImprovement';
import UserFooter from './UserFooter';
import { useNavigate } from 'react-router-dom';
import ChatComponent from './ChatComponent';

const AnalyticsPage = () => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const navigate = useNavigate();

  const [userPlanID, setUserPlanID] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      window.location.href = '/';
    } else {
      fetch('https://18.117.231.157/api/getuserplan', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ userID: user.userID })
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setUserPlanID(data.plan);
          } else {
            console.error('Failed to fetch user plan:', data.message);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching user plan:', error);
          setLoading(false);
        });
    }
  }, [user?.userID]);

  const handlePrint = () => {
    window.print();  // Directly call the browser's print function
};

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '4rem' }}>Loading analytics...</div>;
  }

  if (!userPlanID) {
    return (
      <div>
        <ProfileNavBar />
        <br></br>
        <div style={{ textAlign: 'center', padding: '6rem 2rem' }}>
          <h2 className='contactuspageheaders'>Please choose a goal plan to generate analytics</h2>
          <button
            className="goals"
            onClick={() => navigate('/bmicalculator')}
            style={{ marginTop: '1rem' }}
          >
            Go to BMI Calculator
          </button>
        </div>
        <UserFooter/>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <ProfileNavBar />
      <br /><br /><br /><br /><br /><br />

      <div>
        <AreasOfImprovementChart />
      </div>

      <div className='rowtype' style={{ gap: '0px' }}>
        <div className='columntype'>
          <MultiActivityGoalCalendar user={user.userID} />
        </div>
        <div style={{ width: '80%' }}>
          <UserComparison user={user.userID} />
        </div>
      </div>
      <div className='goalsdiv'>
      <button onClick={handlePrint} className='goals'>Export This Page</button>
      </div>
      <ChatComponent/>
      <br /><br /><br />
      <UserFooter />
      <Footer />
    </div>
  );
};

export default AnalyticsPage;
